// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/product.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Asset_Amount } from "./asset.ts";
/**
 * @generated from protobuf message mlmbox.types.Invoice
 */
export interface Invoice {
}
/**
 * @generated from protobuf message mlmbox.types.Invoice.Request
 */
export interface Invoice_Request {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Invoice.Request.Entity entities = 2;
     */
    entities: Invoice_Request_Entity[];
}
/**
 * @generated from protobuf message mlmbox.types.Invoice.Request.Entity
 */
export interface Invoice_Request_Entity {
    /**
     * @generated from protobuf field: uint32 tree_id = 1;
     */
    treeId: number;
    /**
     * @generated from protobuf field: uint32 quantity = 2;
     */
    quantity: number;
}
/**
 * @generated from protobuf message mlmbox.types.Invoice.PreviewResponse
 */
export interface Invoice_PreviewResponse {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Invoice.PreviewResponse.Item items = 1;
     */
    items: Invoice_PreviewResponse_Item[];
    /**
     * @generated from protobuf field: repeated mlmbox.types.Asset.Amount bill_amounts = 2;
     */
    billAmounts: Asset_Amount[];
}
/**
 * @generated from protobuf message mlmbox.types.Invoice.PreviewResponse.Item
 */
export interface Invoice_PreviewResponse_Item {
    /**
     * @generated from protobuf field: uint32 tree_id = 1;
     */
    treeId: number;
    /**
     * @generated from protobuf field: uint32 asset_id = 2;
     */
    assetId: number;
    /**
     * @generated from protobuf field: string price_value = 3;
     */
    priceValue: string;
    /**
     * @generated from protobuf field: string unlock_value = 4;
     */
    unlockValue: string;
    /**
     * @generated from protobuf field: string amount_value = 5;
     */
    amountValue: string;
    /**
     * @generated from protobuf field: uint32 quantity = 6;
     */
    quantity: number;
}
/**
 * @generated from protobuf message mlmbox.types.Invoice.VerifiedResponse
 */
export interface Invoice_VerifiedResponse {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Invoice.VerifiedResponse.Item items = 1;
     */
    items: Invoice_VerifiedResponse_Item[];
}
/**
 * @generated from protobuf message mlmbox.types.Invoice.VerifiedResponse.Item
 */
export interface Invoice_VerifiedResponse_Item {
    /**
     * @generated from protobuf field: uint32 tree_id = 1;
     */
    treeId: number;
    /**
     * @generated from protobuf field: uint32 tree_entity_id = 2;
     */
    treeEntityId: number;
    /**
     * @generated from protobuf field: uint32 tree_account_entity_id = 3;
     */
    treeAccountEntityId: number;
    /**
     * @generated from protobuf field: uint32 position_id = 4;
     */
    positionId: number;
    /**
     * @generated from protobuf field: bool is_booking = 5;
     */
    isBooking: boolean;
}
/**
 * @generated from protobuf message mlmbox.types.AiLinkResponse
 */
export interface AiLinkResponse {
    /**
     * @generated from protobuf field: string link = 1;
     */
    link: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Invoice$Type extends MessageType<Invoice> {
    constructor() {
        super("mlmbox.types.Invoice", []);
    }
    create(value?: PartialMessage<Invoice>): Invoice {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Invoice>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Invoice): Invoice {
        return target ?? this.create();
    }
    internalBinaryWrite(message: Invoice, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Invoice
 */
export const Invoice = new Invoice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Invoice_Request$Type extends MessageType<Invoice_Request> {
    constructor() {
        super("mlmbox.types.Invoice.Request", [
            { no: 2, name: "entities", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Invoice_Request_Entity }
        ]);
    }
    create(value?: PartialMessage<Invoice_Request>): Invoice_Request {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entities = [];
        if (value !== undefined)
            reflectionMergePartial<Invoice_Request>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Invoice_Request): Invoice_Request {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Invoice.Request.Entity entities */ 2:
                    message.entities.push(Invoice_Request_Entity.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Invoice_Request, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Invoice.Request.Entity entities = 2; */
        for (let i = 0; i < message.entities.length; i++)
            Invoice_Request_Entity.internalBinaryWrite(message.entities[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Invoice.Request
 */
export const Invoice_Request = new Invoice_Request$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Invoice_Request_Entity$Type extends MessageType<Invoice_Request_Entity> {
    constructor() {
        super("mlmbox.types.Invoice.Request.Entity", [
            { no: 1, name: "tree_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Invoice_Request_Entity>): Invoice_Request_Entity {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.treeId = 0;
        message.quantity = 0;
        if (value !== undefined)
            reflectionMergePartial<Invoice_Request_Entity>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Invoice_Request_Entity): Invoice_Request_Entity {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 tree_id */ 1:
                    message.treeId = reader.uint32();
                    break;
                case /* uint32 quantity */ 2:
                    message.quantity = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Invoice_Request_Entity, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 tree_id = 1; */
        if (message.treeId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.treeId);
        /* uint32 quantity = 2; */
        if (message.quantity !== 0)
            writer.tag(2, WireType.Varint).uint32(message.quantity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Invoice.Request.Entity
 */
export const Invoice_Request_Entity = new Invoice_Request_Entity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Invoice_PreviewResponse$Type extends MessageType<Invoice_PreviewResponse> {
    constructor() {
        super("mlmbox.types.Invoice.PreviewResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Invoice_PreviewResponse_Item },
            { no: 2, name: "bill_amounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Asset_Amount }
        ]);
    }
    create(value?: PartialMessage<Invoice_PreviewResponse>): Invoice_PreviewResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        message.billAmounts = [];
        if (value !== undefined)
            reflectionMergePartial<Invoice_PreviewResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Invoice_PreviewResponse): Invoice_PreviewResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Invoice.PreviewResponse.Item items */ 1:
                    message.items.push(Invoice_PreviewResponse_Item.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated mlmbox.types.Asset.Amount bill_amounts */ 2:
                    message.billAmounts.push(Asset_Amount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Invoice_PreviewResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Invoice.PreviewResponse.Item items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Invoice_PreviewResponse_Item.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated mlmbox.types.Asset.Amount bill_amounts = 2; */
        for (let i = 0; i < message.billAmounts.length; i++)
            Asset_Amount.internalBinaryWrite(message.billAmounts[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Invoice.PreviewResponse
 */
export const Invoice_PreviewResponse = new Invoice_PreviewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Invoice_PreviewResponse_Item$Type extends MessageType<Invoice_PreviewResponse_Item> {
    constructor() {
        super("mlmbox.types.Invoice.PreviewResponse.Item", [
            { no: 1, name: "tree_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "asset_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "price_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "unlock_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "amount_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "quantity", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Invoice_PreviewResponse_Item>): Invoice_PreviewResponse_Item {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.treeId = 0;
        message.assetId = 0;
        message.priceValue = "";
        message.unlockValue = "";
        message.amountValue = "";
        message.quantity = 0;
        if (value !== undefined)
            reflectionMergePartial<Invoice_PreviewResponse_Item>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Invoice_PreviewResponse_Item): Invoice_PreviewResponse_Item {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 tree_id */ 1:
                    message.treeId = reader.uint32();
                    break;
                case /* uint32 asset_id */ 2:
                    message.assetId = reader.uint32();
                    break;
                case /* string price_value */ 3:
                    message.priceValue = reader.string();
                    break;
                case /* string unlock_value */ 4:
                    message.unlockValue = reader.string();
                    break;
                case /* string amount_value */ 5:
                    message.amountValue = reader.string();
                    break;
                case /* uint32 quantity */ 6:
                    message.quantity = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Invoice_PreviewResponse_Item, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 tree_id = 1; */
        if (message.treeId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.treeId);
        /* uint32 asset_id = 2; */
        if (message.assetId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.assetId);
        /* string price_value = 3; */
        if (message.priceValue !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.priceValue);
        /* string unlock_value = 4; */
        if (message.unlockValue !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.unlockValue);
        /* string amount_value = 5; */
        if (message.amountValue !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.amountValue);
        /* uint32 quantity = 6; */
        if (message.quantity !== 0)
            writer.tag(6, WireType.Varint).uint32(message.quantity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Invoice.PreviewResponse.Item
 */
export const Invoice_PreviewResponse_Item = new Invoice_PreviewResponse_Item$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Invoice_VerifiedResponse$Type extends MessageType<Invoice_VerifiedResponse> {
    constructor() {
        super("mlmbox.types.Invoice.VerifiedResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Invoice_VerifiedResponse_Item }
        ]);
    }
    create(value?: PartialMessage<Invoice_VerifiedResponse>): Invoice_VerifiedResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Invoice_VerifiedResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Invoice_VerifiedResponse): Invoice_VerifiedResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Invoice.VerifiedResponse.Item items */ 1:
                    message.items.push(Invoice_VerifiedResponse_Item.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Invoice_VerifiedResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Invoice.VerifiedResponse.Item items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Invoice_VerifiedResponse_Item.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Invoice.VerifiedResponse
 */
export const Invoice_VerifiedResponse = new Invoice_VerifiedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Invoice_VerifiedResponse_Item$Type extends MessageType<Invoice_VerifiedResponse_Item> {
    constructor() {
        super("mlmbox.types.Invoice.VerifiedResponse.Item", [
            { no: 1, name: "tree_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "tree_entity_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "tree_account_entity_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "position_id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "is_booking", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Invoice_VerifiedResponse_Item>): Invoice_VerifiedResponse_Item {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.treeId = 0;
        message.treeEntityId = 0;
        message.treeAccountEntityId = 0;
        message.positionId = 0;
        message.isBooking = false;
        if (value !== undefined)
            reflectionMergePartial<Invoice_VerifiedResponse_Item>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Invoice_VerifiedResponse_Item): Invoice_VerifiedResponse_Item {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 tree_id */ 1:
                    message.treeId = reader.uint32();
                    break;
                case /* uint32 tree_entity_id */ 2:
                    message.treeEntityId = reader.uint32();
                    break;
                case /* uint32 tree_account_entity_id */ 3:
                    message.treeAccountEntityId = reader.uint32();
                    break;
                case /* uint32 position_id */ 4:
                    message.positionId = reader.uint32();
                    break;
                case /* bool is_booking */ 5:
                    message.isBooking = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Invoice_VerifiedResponse_Item, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 tree_id = 1; */
        if (message.treeId !== 0)
            writer.tag(1, WireType.Varint).uint32(message.treeId);
        /* uint32 tree_entity_id = 2; */
        if (message.treeEntityId !== 0)
            writer.tag(2, WireType.Varint).uint32(message.treeEntityId);
        /* uint32 tree_account_entity_id = 3; */
        if (message.treeAccountEntityId !== 0)
            writer.tag(3, WireType.Varint).uint32(message.treeAccountEntityId);
        /* uint32 position_id = 4; */
        if (message.positionId !== 0)
            writer.tag(4, WireType.Varint).uint32(message.positionId);
        /* bool is_booking = 5; */
        if (message.isBooking !== false)
            writer.tag(5, WireType.Varint).bool(message.isBooking);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Invoice.VerifiedResponse.Item
 */
export const Invoice_VerifiedResponse_Item = new Invoice_VerifiedResponse_Item$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AiLinkResponse$Type extends MessageType<AiLinkResponse> {
    constructor() {
        super("mlmbox.types.AiLinkResponse", [
            { no: 1, name: "link", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AiLinkResponse>): AiLinkResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.link = "";
        if (value !== undefined)
            reflectionMergePartial<AiLinkResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AiLinkResponse): AiLinkResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string link */ 1:
                    message.link = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AiLinkResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string link = 1; */
        if (message.link !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.link);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.AiLinkResponse
 */
export const AiLinkResponse = new AiLinkResponse$Type();
